// Mercapoli - Explorar Restaurantes con Mapa
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, Map, List, Search } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import CustomerLayout from '../../layouts/CustomerLayout';
import RestaurantMap from '../../components/RestaurantMap';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_mercadelivery-1/artifacts/5y038jeg_icono_mercapoli.png";

const ExplorePage = () => {
  const navigate = useNavigate();
  const [viewMode, setViewMode] = useState('map');
  const [selectedRestaurant, setSelectedRestaurant] = useState(null);

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="sticky top-0 z-50 glass border-b border-border/50">
        <div className="container mx-auto px-4">
          <div className="flex items-center h-16 gap-4">
            <button onClick={() => navigate('/app')} className="p-2 -ml-2 rounded-lg hover:bg-muted">
              <ArrowLeft className="h-5 w-5" />
            </button>
            <div className="flex items-center gap-2">
              <img src={LOGO_URL} alt="Mercapoli" className="h-8 w-8" />
              <h1 className="font-heading text-lg font-bold">Explorar</h1>
            </div>
          </div>
        </div>
      </header>

      <main className="container mx-auto px-4 py-6 max-w-6xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <div className="mb-6">
            <h2 className="text-2xl font-heading font-bold mb-2">
              Restaurantes cerca de ti
            </h2>
            <p className="text-muted-foreground">
              Encuentra los mejores restaurantes con la tarifa de entrega calculada según la distancia
            </p>
          </div>

          {/* Map Component */}
          <RestaurantMap
            height="500px"
            onSelectRestaurant={setSelectedRestaurant}
          />
        </motion.div>
      </main>
    </div>
  );
};

export default ExplorePage;
